import type { FC } from 'react'
import { useMemo } from 'react'

import type { IPhotos } from '../../../../../api/interfaces/events/interfaces.model'
import { EmptyData } from '../../../../../components/atoms/EmptyData/EmptyData'
import { SGallery } from './Gallery.styled'

export interface IPhotoProps {
  photos: IPhotos[]
}

export const GalleryEvents: FC<IPhotoProps> = ({ photos }) => {
  const gallery = useMemo(
    () =>
      photos.map((photo: IPhotos) => (
        <SGallery key={photo.file_name}>
          {/* TODO: Use <Image /> from next/image */}
          <img
            src={`${process.env.NEXT_PUBLIC_REACT_APP_URL}${photo.file_link}`}
            alt={photo.file_link}
            height={400}
            width={300}
          />
        </SGallery>
      )),
    [photos],
  )

  const iSGallery = useMemo(
    () => (gallery.length ? gallery : <EmptyData />),
    [gallery],
  )

  return <SGallery>{iSGallery}</SGallery>
}
